import AV from 'leancloud-storage'

export const Topic = AV.Object.extend('Topic')

Topic.getById = function (objectId) {
    return AV.Cloud.rpc('getTopicById', { topicId: objectId, ttl: 600 })
}

// 获取最新话题帖子
Topic.getLatestTopicPosts = function (id, page = 1) {
    return AV.Cloud.rpc('getLatestTopicPosts', { page, topicId: id }).then((posts) => {
        return posts.filter(p => p.className).map(p => p.toJSON())
    })
}

// 获取最热话题帖子
Topic.getHotTopicPosts = function (id, page = 1) {
    return AV.Cloud.rpc('getHotTopicPosts', { page, topicId: id }).then((posts) => {
        return posts.filter(p => p.className).map(p => p.toJSON())
    })
}

// 获取全部话题
Topic.getTopics = function (page = 1, perPage = 15) {
    return AV.Cloud.rpc('getTopics', { page, perPage })
}

// 获取全部接龙
Topic.getJielongTopics = function (page = 1, perPage = 15) {
    return AV.Cloud.rpc('getTopicsByKind', { page, perPage, kind: 2 })
}

// 获取全部飞花令
Topic.getFeihuaTopics = function (page = 1, perPage = 15) {
    return AV.Cloud.rpc('getTopicsByKind', { page, perPage, kind: 3 })
}

// 获取最新话题回复
Topic.getLatestReplies = function (id, page = 1) {
    return AV.Cloud.rpc('getLatestTopicReplies2', { page, topicId: id })
}

// 获取接龙最新回复
Topic.prototype.getJielongLatestReply = function () {
    let functionName = this.get('subKind') == 0 ? "getJielongTopicLatestReply" : "getReverseJielongTopicLatestReply"

    return AV.Cloud.run(functionName, { topicId: this.id })
}

// 提交接龙
Topic.prototype.addJielongReply = function (reply, latestReplyId, tips) {
    let functionName = this.get('subKind') == 0 ? "addJielongTopicReply3" : "addReverseJielongTopicReply"

    return AV.Cloud.rpc(functionName, { reply, topicId: this.id, latestReplyId, tips })
}

// 提交飞花令
Topic.prototype.addFeihuaReply = function (reply) {
    return AV.Cloud.rpc('addFeihuaTopicReply', { reply, topicId: this.id, keyword: this.get('keyword') })
}



// WEBPACK FOOTER //
// ./src/models/topic.js